/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum BackupOptionsTarget {
    IncludedItems = 'includedItems',
    ExcludedItems = 'excludedItems',
}